module.exports = {"id":"211176","name":"Ricardo Kishna","rating":"74","photo":"./data/images/photos/4/211176.png","club":{"name":"ADO La Haye","logo":"./data/images/clubs/ADOLaHaye.png"},"positions":["AG","MG","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RicardoKishna0.json
// module id = 3593
// module chunks = 0